import { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import {
  ProgressBar,
  ScrollMode,
  Viewer,
  ViewMode,
  Worker,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import resume from "./Resume.pdf";

const Resume = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    const i = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);

    return () => clearTimeout(i);
  }, []);

  const characterMap = {
    isCompressed: true,
    url: "https://unpkg.com/pdfjs-dist@2.6.347/cmaps/",
  };

  const renderPage = (props) => {
    return (
      <>
        {props.canvasLayer.children}
        <div style={{ userSelect: "none" }}>{props.textLayer.children}</div>
        {props.annotationLayer.children}
      </>
    );
  };

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <div className="Rescon">
        <div className="resTxt">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["M", "y", " ", "R", "e", "s", "u", "m", "e"]}
              idx={15}
            />
          </h1>
        </div>

        <div className="pdf-zone">
          <Viewer
            fileUrl={resume}
            viewMode={ViewMode.SinglePage}
            characterMap={characterMap}
            enableSmoothScroll={true}
            scrollMode={ScrollMode.Vertical}
            renderPage={renderPage}
            initialPage={0}
            renderLoader={(percentages) => (
              <div style={{ width: "60%" }}>
                <ProgressBar progress={Math.round(percentages)} />
              </div>
            )}
            theme={{
              theme: "dark",
            }}
          />
        </div>
      </div>

      <Loader type="pacman" />
    </Worker>
  );
};

export default Resume;
